import type { CartEntry } from '@maestro/data-layer'

const IMPORT_LINE_PATTERN = /^\s*([\w-]+)\s*,\s*(\d+)\s*$/

export interface ParsedCartImportItem {
  itemNumber: string
  quantity: number
}

export interface ParsedCartImportText {
  items: ParsedCartImportItem[]
  invalidLines: number[]
}

export function parseCartImportText(text: string): ParsedCartImportText {
  const quantityByItemNumber = new Map<string, number>()
  const invalidLines: number[] = []

  text.split('\n').forEach((line, index) => {
    if (!line.trim()) {
      return
    }

    const match = IMPORT_LINE_PATTERN.exec(line)
    if (!match) {
      invalidLines.push(index + 1)
      return
    }

    const [, itemNumber, quantityText] = match
    const quantity = Number.parseInt(quantityText, 10)
    quantityByItemNumber.set(
      itemNumber,
      (quantityByItemNumber.get(itemNumber) ?? 0) + quantity
    )
  })

  const items = Array.from(quantityByItemNumber, ([itemNumber, quantity]) => ({
    itemNumber,
    quantity,
  }))

  return {
    items,
    invalidLines,
  }
}

export function convertCartEntriesToCsv(entries: CartEntry[]): string {
  return entries
    .map((entry) => `${entry.variantId},${entry.quantity}`)
    .join('\n')
}
